import { useEffect } from "react";
import { ensureNamespaceLoaded } from "./lazyNamespaces";

/**
 * Pré-carrega namespaces lazy conforme a rota (MainLayout).
 */
export function useLazyI18nNamespaces(pathname) {
  useEffect(() => {
    const p = pathname || "";
    const tasks = [];

    if (p.startsWith("/products") || p.startsWith("/passenger-cities")) {
      tasks.push(ensureNamespaceLoaded("products"));
    }
    if (p.startsWith("/surveys")) tasks.push(ensureNamespaceLoaded("surveys"));
    if (
      p.startsWith("/settings") ||
      p.startsWith("/categories") ||
      p.startsWith("/coupons") ||
      p.startsWith("/banners") ||
      p.startsWith("/contents") ||
      p.startsWith("/pipeline") ||
      p.includes("/equipe/pipeline") ||
      p.includes("/popup-equipe/pipeline") ||
      p.startsWith("/sales-pipeline") ||
      p.startsWith("/clients") ||
      p.startsWith("/agents") ||
      p.startsWith("/awareness-stages") ||
      p.startsWith("/pipeline-stages") ||
      p.startsWith("/campaigns") ||
      p.startsWith("/surveys") ||
      p.startsWith("/user-details") ||
      p.startsWith("/user-plan")
    ) {
      tasks.push(ensureNamespaceLoaded("settings"));
    }
    if (p === "/" || p === "/chat" || p.startsWith("/chat/")) {
      tasks.push(ensureNamespaceLoaded("chat"));
      tasks.push(ensureNamespaceLoaded("teamTasks"));
    }
    if (p.startsWith("/equipe") || p.startsWith("/popup-equipe")) {
      tasks.push(ensureNamespaceLoaded("team"));
      tasks.push(ensureNamespaceLoaded("teamTasks"));
      tasks.push(ensureNamespaceLoaded("teamAgenda"));
    }
    if (p.includes("/platform/xprobase/team") || p.includes("/partner/console/team")) {
      tasks.push(ensureNamespaceLoaded("team"));
    }
    if (p.includes("/settings/chatbot")) tasks.push(ensureNamespaceLoaded("chatbot"));
    if (p.startsWith("/dashboard")) {
      tasks.push(ensureNamespaceLoaded("dashboard"));
      tasks.push(ensureNamespaceLoaded("onboarding"));
    }

    void Promise.all(tasks);
  }, [pathname]);
}
